import * as angular from 'angular';
import template from './dataPointsSelector.tpl.html';
import heyeDataPoints from './heyeDataPoints.directive';
import plcDataPoints from './plcDataPoints.directive';
import flexIsDataPoints from './flexIsDataPoints.directive';
import raspberryPiDataPoints from './raspberryPiDataPoints.directive';
import counterSimpleDataPoints from './CounterSimpleDataPoints.directive';
import monitoringDataPoints from './MonitoringDataPoints.directive';
import cbitDataPoints from './cbitDataPoints.directive';

let requires = [plcDataPoints, heyeDataPoints, raspberryPiDataPoints, flexIsDataPoints, counterSimpleDataPoints, monitoringDataPoints, cbitDataPoints];

export default angular.module('aps.controller.dataPointsSelector', requires)
  .directive('apsDataPointsSelector', (): angular.IDirective => {
    return {
      restrict: 'E',
      template: template
    };
  })
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/equipment/dataPointsSelector.directive.ts